import { memo } from 'react';

import { type PublicBoard } from '@air/api/types';

import { type ItemProps } from '~/components/Gallery/types';
import { PublicTableAssetTitle } from '~/components/TableView/NameCell/NameCellContent/PublicTableAssetTitle';
import { BoardMetaData } from '../NameCell/BoardNameCell/BoardMetaData';

export type PublicBoardNameCellTitleProps = {
  onClick: ItemProps['onItemClick'];
  onCmdClick?: ItemProps['onItemCmdClick'];
  board: PublicBoard;
};

export const PublicBoardNameCellTitle = memo(({ onClick, onCmdClick, board }: PublicBoardNameCellTitleProps) => {
  return (
    <div className="relative ml-3" data-disableselect="true">
      <PublicTableAssetTitle title={board.title} onClick={onClick} onCmdClick={onCmdClick} />
      <BoardMetaData itemCount={board.directDescendantCount} />
    </div>
  );
});

PublicBoardNameCellTitle.displayName = 'PublicBoardNameCellTitle';
